module.exports = __webpack_public_path__ + "static/media/Vector.5a8667a7.svg";